import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "../../Models/User";
import { UserFilters } from "Interfaces/UserFilters";
import { UserRoles } from "Enums/UserRoles";
import { GridSortItem } from "@mui/x-data-grid";

interface IUserState {
  user: IUser | null;
  searchText: string;
  pageIndex: number;
  pageNumber: number;
  pageSize: number;
  total: number;
  sort: GridSortItem[];
  group_ids?: string;
  filters: UserFilters;
}

const initialState: IUserState = {
  user: null,
  searchText: "",
  pageIndex: 0,
  pageNumber: 0,
  pageSize: 6,
  total: 0,
  sort: [
    {
      field: "name",
      sort: "asc",
    },
  ],
  filters: {
    roles: [UserRoles.SUPERADMIN],
  },
};

export const userSlice = createSlice({
  initialState,
  name: "userSlice",
  reducers: {
    logout: () => initialState,
    setUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
    setGroupIds: (state, action: PayloadAction<string>) => {
      state.group_ids = action.payload;
    },
    updateFilters: (state, action: PayloadAction<UserFilters>) => {
      state.filters = action.payload;
    },
  },
});

export default userSlice.reducer;

export const { logout, setUser } = userSlice.actions;
